export default __webpack_public_path__ + "static/media/Bow of the Unseen.20d8b5d5.jpg";